export default __webpack_public_path__ + "static/media/icon-notifications-new.41257d6b.svg";